var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.aRemplacer)?_c('v-list-item',{on:{"click":function($event){return _vm.nePasRemplacer(_vm.creneau.creneauId)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("fa-people-arrows")])],1),_c('v-list-item-title',[_vm._v(_vm._s(_vm.label))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }